import { Action } from '../types';

export interface State {
  /* Whether or not the modal that we render the AWS Captcha challenge puzzle in is open */
  isCaptchaPuzzleModalOpen: boolean;
}

export const defaultState: State = {
  isCaptchaPuzzleModalOpen: false,
};

const awsCaptcha = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case 'OPEN_AWS_CAPTCHA_MODAL':
      return {
        ...state,
        isCaptchaPuzzleModalOpen: true,
      };
    case 'CLOSE_AWS_CAPTCHA_MODAL':
      return {
        ...state,
        isCaptchaPuzzleModalOpen: false,
      };
    default:
      return state;
  }
};

export default awsCaptcha;
